module.exports = __webpack_public_path__ + "img/flow5.e2d32c3d.png";